import { FeatureTypes } from "./feature.types";

const initialState = {
    headersColor: {
        detail:'',
        home:'',
        setColor: false
    },
    authModal: false

}

export const featureReducer = (state=initialState,action) => {
    switch (action.type) {
        case FeatureTypes.changeHeaderColor:
            return {
                ...state,
                headersColor: {
                    detail:'#000',
                    home:'#fff',
                    setColor: true
                }
            }
        case FeatureTypes.SET_AUTH_MODAL:
            return {
                ...state,
                authModal: action.payload
            }  
        
    
        default:
            return state;
    }
}